// src/scripts/audits/venueAuditConfigs/london-stone-wokingAudit.js

import { buildManagersOfficeSection } from "@/scripts/audits/shared/managersOfficeSection";

const venueSections = [
  {
    id: "outside",
    title: "Outside",
    icon: "store",
    items: [
      { key: "v1", label: "Shopfront Fasica Clean" },
      { key: "v2", label: "Windows Clean" },
      { key: "v3", label: "POS all in date" },
      { key: "v4", label: "All bulbs working" },
      { key: "v5", label: "Signage Working" },
      { key: "v6", label: "Correct Graphics & Signage" },
      { key: "v7", label: "Alarm Working" },
    ],
  },

  {
    id: "garden",
    title: "Garden",
    icon: "deck",
    items: [
      {
        key: "v8",
        label: "Garden / terrace floor clean",
      },
      {
        key: "v9",
        label: "Floor free from litter, cigarette ends and broken glass",
      },
      {
        key: "v10",
        label: "Paving / flooring free from trip hazards",
      },
      {
        key: "v11",
        label: "Railings and barriers secure and undamaged",
      },
      {
        key: "v12",
        label: "Entrance and exit routes clear",
      },
      {
        key: "v13",
        label: "Steps and access points safe and unobstructed",
      },
      {
        key: "v14",
        label: "Tables clean and presentable",
      },
      {
        key: "v15",
        label: "All Weeds removed",
      },
      {
        key: "v16",
        label: "Furniture laid out correctly and not obstructing access",
      },
      {
        key: "v17",
        label: "Ashtrays clean and emptied",
      },
      {
        key: "v18",
        label: "No abandoned glasses or bottles",
      },
      {
        key: "v19",
        label: "Area free from standing water or slip hazards",
      },
      {
        key: "v20",
        label: "External fixtures and fittings secure and undamaged",
      },
    ],
  },

  {
    id: "customerArea",
    title: "Guest Area",
    icon: "weekend",
    items: [
      {
        key: "v21",
        label: "Floor polished & clean",
      },
      {
        key: "v22",
        label: "Skirting clean with no polish build-up",
      },
      {
        key: "v23",
        label: "Tables <b>NOT</b> sticky",
      },
      {
        key: "v24",
        label: "No chewing gum",
      },
      {
        key: "v25",
        label: "Walls clean with no marks/scuffs",
      },
      {
        key: "v26",
        label: "Aircon Extract grills clean",
      },
      {
        key: "v27",
        label: "Door Frames",
      },
      {
        key: "v28",
        label: "Kick plates clean",
      },
      {
        key: "v29",
        label: "All Bulbs working",
      },
      {
        key: "v30",
        label: "Doors closing properly",
      },
      {
        key: "v31",
        label: "Bar-Top clean",
      },
      {
        key: "v32",
        label: "Bar front chewing gum free",
      },
      {
        key: "v33",
        label: "Beer Taps Working and complete",
      },
      {
        key: "v34",
        label: "POS in date",
      },
      {
        key: "v35",
        label: "No Paint Chipped",
      },
      {
        key: "v36",
        label: "Tills marked correctly & draws Working",
      },
      {
        key: "v37",
        label: "All metal polished",
      },
      {
        key: "v38",
        label: "Staircase & Risers clean",
      },
      {
        key: "v39",
        label: "Fire Equipment in correct position",
      },
      {
        key: "v40",
        label: "All fixed seating clean & no rips",
      },
      {
        key: "v41",
        label: "Darts Board on and working",
      },
      {
        key: "v42",
        label: "Photobooth on and Working",
      },
      {
        key: "v43",
        label: "Pool Table has no Rips and is Working",
      },
      {
        key: "v44",
        label: "All Ad Screens On, Working and up to Date",
      },
    ],
  },

  {
    id: "toiletsDisabled",
    title: "Toilets & Disabled",
    icon: "wc",
    items: [
      {
        key: "v45",
        label: "Hand dryers working",
      },
      {
        key: "v46",
        label: "Toilet papaer dispensers full & working",
      },
      {
        key: "v47",
        label: "Soap dispensers full",
      },
      {
        key: "v48",
        label: "Toilet blocks/pads present",
      },
      {
        key: "v49",
        label: "No Urine/Drain odour present",
      },
      {
        key: "v50",
        label: "Cubical locks working",
      },
      {
        key: "v51",
        label: "Toilets flush",
      },
      {
        key: "v52",
        label: "Floor Seats not broken",
      },
      {
        key: "v53",
        label: "Floor clean",
      },
      {
        key: "v54",
        label: "Taps working",
      },
      {
        key: "v55",
        label: "Urinals flush",
      },
      {
        key: "v56",
        label: "POS in date",
      },
      {
        key: "v57",
        label: "Walls clean with no marks",
      },
      {
        key: "v58",
        label: "Mirrors clean with no smears",
      },
      {
        key: "v59",
        label: "Tampon bins correct",
      },
      {
        key: "v60",
        label: "Lights working",
      },
      {
        key: "v61",
        label: "Hot water working",
      },
    ],
  },

  {
    id: "staffAreas",
    title: "Staff Areas & Toilets",
    icon: "badge",
    items: [
      {
        key: "v62",
        label: "Staff toilets clean",
      },
      {
        key: "v63",
        label: "Soap & Nail brushes present",
      },
      {
        key: "v64",
        label: "Toilet paper dispensers full & working",
      },
      {
        key: "v65",
        label: "Signage Up",
      },
      {
        key: "v66",
        label: "Floors & Walls clean",
      },
      {
        key: "v67",
        label: "Locks working",
      },
      {
        key: "v68",
        label: "Lights Working",
      },
      {
        key: "v69",
        label: "Lockers Tidy",
      },
      {
        key: "v70",
        label: "No Clutter",
      },
    ],
  },

  {
    id: "backOfHouse",
    title: "Back of House",
    icon: "inventory_2",
    items: [
      {
        key: "v71",
        label: "Bin area clean",
      },
      {
        key: "v72",
        label: "Area clean & tidy, free of clutter",
      },
      {
        key: "v73",
        label: "Heath & Safety poster displayed",
      },
      {
        key: "v74",
        label: "Promotional items stored correctly",
      },
      {
        key: "v75",
        label: "First-Aid boxes in correct locations & full",
      },
    ],
  },

  {
    id: "dj",
    title: "DJ Consul & Effects",
    icon: "graphic_eq",
    items: [
      {
        key: "v76",
        label: "Sound equipment all working",
      },
      {
        key: "v77",
        label: "Lighting all working",
      },
    ],
  },

  {
    id: "glasswasher-room",
    title: "Glasswasher Room",
    icon: "local_bar",
    items: [
      {
        key: "v78",
        label: "Floor clean and free from slip or trip hazards",
      },
      {
        key: "v79",
        label: "Glasswasher clean and in good working order",
      },
      {
        key: "v80",
        label: "Glasswasher filters and wash arms clean",
      },
      {
        key: "v81",
        label: "Glasswasher chemicals connected and sufficiently stocked",
      },
      {
        key: "v82",
        label: "Chemical containers correctly labelled and safely stored",
      },
      {
        key: "v83",
        label: "Sink and surrounding work surfaces clean",
      },
      {
        key: "v84",
        label: "Glasswasher racks clean and in good condition",
      },
      {
        key: "v85",
        label: "Shelving and storage areas clean and organised",
      },
      {
        key: "v86",
        label: "No broken or chipped glassware present",
      },
      {
        key: "v87",
        label:
          "Waste and broken glass containers correctly used and not overflowing",
      },
      {
        key: "v88",
        label: "Area free from unnecessary stock, clutter and equipment",
      },
      {
        key: "v89",
        label: "Walls, doors and fixtures clean and in good condition",
      },
      {
        key: "v90",
        label: "Lighting fully operational",
      },
    ],
  },

  {
    id: "bars",
    title: "Bars",
    icon: "local_bar",
    items: [
      {
        key: "v91",
        label: "PDQ on charge & working",
      },
      {
        key: "v92",
        label: "Bar back clean & tidy",
      },
      {
        key: "v93",
        label: "Mirrors Polished",
      },
      {
        key: "v94",
        label: "TV Screens Clean",
      },
      {
        key: "v95",
        label: "Glasswear Clean",
      },
      {
        key: "v96",
        label: "Glasswear in correct order",
      },
      {
        key: "v97",
        label: "Shelving not sticky",
      },
      {
        key: "v98",
        label: "Correct Jiggers in Place",
      },
      {
        key: "v99",
        label: "No stickiness on dispense pumps",
      },
      {
        key: "v100",
        label: "No bar Fly",
      },
      {
        key: "v101",
        label: "Cling-film/Bottle covers in place",
      },
      {
        key: "v102",
        label: "All Spirits locked up",
      },
      {
        key: "v103",
        label: "Fridges stocked correctly",
      },
      {
        key: "v104",
        label: "Glasswash Empty",
      },
      {
        key: "v105",
        label: "No dirty glasses",
      },
      {
        key: "v106",
        label: "Floor clean & not sticky",
      },
      {
        key: "v107",
        label: "Lights Working",
      },
      {
        key: "v108",
        label: "Fridges working & clean",
      },
      {
        key: "v109",
        label: "Post-Mix calibrated",
      },
      {
        key: "v110",
        label: "Tills working",
      },
      {
        key: "v111",
        label: "Correct signage in place",
      },
      {
        key: "v112",
        label: "Price List up-to-date",
      },
      {
        key: "v113",
        label: "Measured 25ml pourers on site",
      },
    ],
  },

  {
    id: "cellar",
    title: "Cellar",
    icon: "warehouse",
    items: [
      {
        key: "v114",
        label: "Spirit room locked",
      },
      {
        key: "v115",
        label: "Cellar door locked",
      },
      {
        key: "v116",
        label: "Cellar clean",
      },
      {
        key: "v117",
        label: "Correct temperature",
      },
      {
        key: "v118",
        label: "Line clean record complete",
      },
      {
        key: "v119",
        label: "Gas cyclinders chained up",
      },
      {
        key: "v120",
        label: "Stocks off of floor",
      },
      {
        key: "v121",
        label: "Stock in correct positions",
      },
      {
        key: "v122",
        label: "Cellar mate active",
      },
      {
        key: "v123",
        label: "Ice Machines working",
      },
      {
        key: "v124",
        label: "Bag-in-Box clean",
      },
      {
        key: "v125",
        label: "Stock at correct levels",
      },
      {
        key: "v126",
        label: "All in date",
      },
      {
        key: "v127",
        label: "Empty barrels, actually empty",
      },
      {
        key: "v128",
        label: "No unauthorised stock",
      },
      {
        key: "v129",
        label: "Empty barrels stacked",
      },
    ],
  },
];

export default {
  id: "london-stone-woking-audit-v1",
  venueId: "london-stone-woking",
  label: "London Stone Woking",

  sectionList: [
    ...venueSections.map((section) => ({
      ...section,
      items: section.items.map((item) => ({
        ...item,
      })),
    })),

    buildManagersOfficeSection(),
  ],
};